import { createI18n } from 'vue-i18n'
/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
function loadLocaleMessages() {
    const locales = require.context('./locales', true, /(?<![\w\-,\s])[\w\-,\s]+\.json$/i)
    const messages = {}
    locales.keys().forEach((key) => {
        // "./en.json" -> "en" (no regex: lookbehind isn't supported in older Safari)
        const locale = key.split('/').pop().split('.')[0]
        if (locale) {
            messages[locale] = locales(key).default
        }
    })
    return messages
}

const i18n = createI18n({
    legacy: false,
    locale: localStorage.getItem('locale') || process.env.VUE_APP_I18N_FALLBACK_LOCALE,
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
    messages: loadLocaleMessages()
})

export default i18n
